import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../shared/shared.module';
import { BookingsComponent } from './bookings.component';
import { BookingsRoutingModule } from './bookings-routing.module';
import { BookingsResolve } from './bookings.resolve';
import { AppMaterialModule } from '../../../shared/appMaterial/app-material.module';
import { EditBookingModule } from './edit/edit-booking.module';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    AppMaterialModule,
    EditBookingModule,
    SharedModule,
    BookingsRoutingModule,
    MatDialogModule,
    ListGridModule,
  ],
  declarations: [BookingsComponent],
  entryComponents: [],
  exports: [BookingsComponent],
  providers: [BookingsResolve],
})
export class BookingsModule {}
